import { Row, Col, Container, Button } from "react-bootstrap";
import { useState } from "react";

const Pricing = ({ setShowRegister }) => {
  const [yearly, setYearly] = useState(true);

  const prices = {
    custom: { monthly: "14.99", yearly: "9.99" },
    full: { monthly: "34.99", yearly: "24.99" },
  };

  const SignupButton = ({ featured }) => {
    const isDemo = window.location.hostname === "demo.freelancersplace.net";
    return (
      <div style={{ marginTop: "1.5rem" }}>
        {isDemo ? (
          <a
            href="https://freelancersplace.net/#signup"
            className={`btn w-100 ${featured ? "btn-primary" : "btn-outline-light"}`}
            style={{ fontWeight: 600, padding: "0.65rem" }}
          >
            Sign up now
          </a>
        ) : (
          <button
            type="button"
            className={`btn w-100 ${featured ? "btn-primary" : "btn-outline-light"}`}
            style={{ fontWeight: 600, padding: "0.65rem" }}
            onClick={() => setShowRegister(true)}
          >
            Sign up now
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="lp-section-alt">
      <Container id="pricing">
        <Row style={{ paddingTop: "4.5rem", paddingBottom: "4.5rem", position: "relative" }}>
          <Col className="bluedotProfile" />
          <Col style={{ textAlign: "center" }}>
            <span className="blueSubheaderTop">Keep it simple</span>
            <div className="landingpageHeader" style={{ fontWeight: "400", lineHeight: "110%", marginTop: "0.5rem" }}>
              Pricing
            </div>

            {/* Toggle */}
            <div style={{ display: "inline-flex", border: "1px solid #dee2e6", borderRadius: "0.5rem", overflow: "hidden", marginBottom: "2rem" }}>
              <button
                onClick={() => setYearly(false)}
                style={{
                  padding: "0.5rem 1.5rem",
                  border: "none",
                  background: !yearly ? "#007BFF" : "transparent",
                  color: !yearly ? "#fff" : "#212529",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "background 0.15s",
                }}
              >
                Monthly
              </button>
              <button
                onClick={() => setYearly(true)}
                style={{
                  padding: "0.5rem 1.5rem",
                  border: "none",
                  borderLeft: "1px solid #dee2e6",
                  background: yearly ? "#007BFF" : "transparent",
                  color: yearly ? "#fff" : "#212529",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "background 0.15s",
                }}
              >
                Yearly
                <span style={{
                  marginLeft: "0.4rem",
                  background: yearly ? "rgba(255,255,255,0.25)" : "#e8f1ff",
                  color: yearly ? "#fff" : "#007BFF",
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  padding: "0.1rem 0.4rem",
                  borderRadius: "0.3rem",
                }}>
                  Save 30%
                </span>
              </button>
            </div>

            {/* Cards */}
            <div className="lp-pricing-cards-row">
              {/* Custom plan */}
              <div className="lp-pricing-card">
                <div className="lp-pricing-plan-name">Custom</div>
                <div className="lp-pricing-price">
                  € {yearly ? prices.custom.yearly : prices.custom.monthly}
                  <span> / month</span>
                </div>
                {yearly && <div style={{ fontSize: "0.8rem", color: "rgba(255,255,255,0.45)", marginBottom: "0.5rem" }}>billed annually</div>}
                <p className="lp-pricing-desc">
                  Only want one module? Pick exactly what you need — Billing,
                  CRM, CVs, Time Tracking or Projects.
                </p>
                <SignupButton featured={false} />
              </div>

              {/* Full experience plan */}
              <div className="lp-pricing-card lp-pricing-featured">
                <div className="lp-pricing-badge">Most popular</div>
                <div className="lp-pricing-plan-name">Full experience</div>
                <div className="lp-pricing-price">
                  € {yearly ? prices.full.yearly : prices.full.monthly}
                  <span> / month</span>
                </div>
                {yearly && <div style={{ fontSize: "0.8rem", color: "rgba(255,255,255,0.45)", marginBottom: "0.5rem" }}>billed annually</div>}
                <p className="lp-pricing-desc">
                  Everything you need to run your freelancing. Missing a
                  feature?{" "}
                  <a href="mailto:felix.dziekan@serie3.de" style={{ color: "rgba(255,255,255,0.6)" }}>Contact us</a>{" "}
                  — if we can build it, you'll get it free.
                </p>
                <SignupButton featured={true} />
              </div>
            </div>

            <p className="landingpageDescriptions" style={{ marginTop: "1.5rem" }}>
              Cancel monthly plans any time. All prices excluding VAT.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Pricing;
